import Button from '@components/Button';
import TextField from '@components/TextField';
import CreateRegionsModal from './partials/CreateRegionsModal';
import Table from '@components/Table';
import Icon from '@material-ui/core/Icon';
import { useState, useEffect } from 'react';
import { apiClient } from '@services/api';
import { connect } from 'react-redux';
import Alert from '@material-ui/lab/Alert';
import BreadCrumbs from '@components/Breadcrumbs';
import StatusSwitch from '@components/StatusSwitch';

const permissions = ['administrador'];

const Index = (props) => {
  document.title = `Lista de regiões - ${process.env.REACT_APP_NAME}`
  const [createModal, setCreateModal] = useState(false);
  const [errorRegion, setErrorRegion] = useState(null)
  const [error, setError] = useState(false);
  const [region, setRegion] = useState(null)
  const [rows] = useState([]);
  const [paginated] = useState(true)
  const [q, setQ] = useState("");

  const bradecrumbsConfig = [
    {
      title: 'Início',
    }
  ]

  const openModalCreate = () => {
    setCreateModal(true);
  }

  const handleCreate = (ev) => {
    ev.preventDefault();
    const body = {
      name: region,
      status: true,
      company_id: props.user.data.company_id
    }
    apiClient.httpInstance.post("/regions", body)
      .then(response => {
        if (response.status === 200 || response.status === 201) {
          setCreateModal(false);
        }
      })
      .catch(error => {
        if (error) {
          setError(true);
          setErrorRegion(error.response.data || "Erro inesperado, tente novamente mais tarde");
          setTimeout(() => { setErrorRegion("") }, 4000);
          setTimeout(() => { setError(false) }, 4000);
        }
      })
  };

  //Oculta menu lateral
  useEffect(() => {
    props.setShowMenu(false)
  }, []);

  return <>
    {error && (
      <Alert className="mb-5" variant="filled" severity="error">
        {errorRegion}
      </Alert>
    )}
    <div className="px-7">
      <div className="flex items-center justify-between mt-2 text-2xl text-blue mb-3">
        <div className="flex items-center">
          <Icon className="mr-2">
            map
          </Icon>
          <span>Lista de regiões</span>
        </div>
        {permissions.includes(props?.theme?.permission) && <Button
          textcolor="#fff"
          padding="6px 15px"
          margintop="0px"
          width="200"
          onClick={openModalCreate}
          customcolor={props.theme.color}
        >
          <Icon className="mr-2">add</Icon>
          Novo
        </Button>}
        <CreateRegionsModal
          open={createModal}
          close={() => setCreateModal(false)}
          onCreate={handleCreate}
          region={region}
          setRegion={setRegion}
          {...props}
        />
      </div>
      <div className="p-4 mt-4 bg-white border-1" style={{ borderRadius: '10px 10px 0px 0px' }}>
        <div className="flex flex-wrap items-center space-x-3">
          <div className="flex-none">
            <TextField
              className="inputRounded"
              label="Busque por uma região"
              width="280px"
              variant="outlined"
              type="text"
              name="q"
              onChange={(ev) => setQ(ev.target.value)}
            />
          </div>
        </div>
      </div>
      <Table
        params={{
          paginated, q
        }}
        path="/regions"
        columns={[
          {
            headerName: 'Nome',
            headerClassName: 'super-app-theme--header',
            field: 'name',
            flex: 2,
          },
          {
            headerName: 'Status',
            headerClassName: 'super-app-theme--header',
            field: 'status',
            flex: 1,
            preventRedirect: true,
            renderCell: (params) => {
              const row = params.row;

              return (<div className="flex items-center pr-4 space-x-5">
                {permissions.includes(props?.theme?.permission) ?
                  <StatusSwitch status={row.status} url={`/regions/${row.id}/status`} />
                  :
                  row.status ? <>Ativa</> : <>Inativa</>
                }
              </div>);
            }
          },
          {
            headerName: 'FT App',
            headerClassName: 'super-app-theme--header',
            field: 'app_enabled',
            flex: 1,
            preventRedirect: true,
            renderCell: (params) => {
              const row = params.row;
              // app_enabled pode ser null/undefined em regiões antigas (assume habilitado)
              const enabled = row.app_enabled !== false && row.app_enabled !== 0;
              return (<div className="flex items-center pr-4 space-x-5">
                {permissions.includes(props?.theme?.permission) ?
                  <StatusSwitch
                    status={enabled}
                    url={`/regions/${row.id}/app-enabled`}
                    field="app_enabled"
                  />
                  :
                  enabled ? <>Ativo</> : <>Inativo</>
                }
              </div>);
            }
          },
        ]}
        rows={rows}
      />
    </div>
  </>
}

const mapStateToProps = state => {
  return {
    user: state.user
  }
}

export default connect(
  mapStateToProps
)(Index);
